import { getLink } from "../../../utils/utils";

const content = {
	esp: (
		`
		<p class="mb-2">
			Ŝajnas, ke demando en la titolo estas naiva: ĉu ne ĉiuj scias, certas, konvinkitas, ke ĝi estas la plej facila el ĉiuj homaj lingvoj?
		</p>
		
		<p class="mb-2">
			Ankaŭ mi tiel pensis; sed multjara sperto de instruisto de Esperanto pli kaj pli konvinkas min je la malo: 
			je tio, ke ne ekzistas facilaj lingvoj, ke ĉiu lingvo facilas aŭ malfacilas laŭ sia propra maniero, kaj tio, kio ŝajnas esti facila por unu persono, tute malfacilas por aliu.
		</p>
		
		<p class="mb-2">
			Oni supozas, ke la ĉefa avantaĝo de Esperanto estas facileco de ĝia gramatiko. 
			Sed… ĉu ĝuste gramatiko estas la obstaklo plej grava por ĉiuj dum lernado de iu lingvo?
		</p>
		
		<p class="mb-2">
			Kiel konate, ekzistas du diversaj tipoj de homa menso: tiu kun domino de dekstra aŭ, respektive, de maldekstra cerba hemisfero. 
			De tio dependas logika aŭ imagema direkto de la menso. 
			Kaj facila strukturo de nia lingvo estas alloga precipe por logikemuloj. 
			Ĝuste por ili estas ĝojo, de la unua fojo ekkompreni la kernon de nia lingvo: ĝian senliman esprimeblecon, konsistantan en «kubeta sistemo», kiam afiksoj kaj radikoj libere kunmetiĝas laŭ deziro de l’ parolanto. 
			Kaj la strikta sistemo de vortfinaĵoj de unu flanko – ordigas tiun kubaron, sed de alia – ankoraŭ plivastigas, multfacetigas ĝin.
		</p>
		
		<p class="mb-2">
			«Kreo de la lingvo», uzado de ĝiaj eblecoj surbaze de la klare komprenataj reguloj – jen estas genia ideo de Zamenhof, kaj nun ĝi estas unu el la ĉefaj atraktiloj por lernado de Esperanto. 
			Sed tio ĉi allogas, kiel mi diris, nur homojn logikemajn, raciemajn, por kiuj la ĝuo estas KOMPRENI, kaj krei mem laŭ la komprenitaj reguloj.
		</p>
		
		<p class="mb-2">
			Do, nia lingvo, estante racia, verŝajne, estas destinita nur por raciemaj homoj?
		</p>
		
		<p class="mb-2">
			Ja tute ne; ni ĉiuj scias, ke ĉe ni abundas individuoj de ambaŭ tipoj.
		</p>
		
		<p class="mb-2">
			Famas la kluboj, kie artemaj personoj instruas la lingvon al samaj artemaj personoj, kantante kaj teatrumante kun ili. 
			Tiam oni ne memorfiksas logikan ĉenon, sed perceptas la vivantan lingvon, kun ĉiuj vortnodoj kaj esprimoj, jam pretan frazon, belstilan kaj belsonan. 
			Oni influas ne racion, sed sentojn de homoj, kiuj estas gvidataj ĝuste per sentoj – kaj pedagogia efekto estas senriproĉa.
		</p>
		
		<p class="mb-2">
			Homoj kun domino de la dekstra hemisfero perceptas la mondon en imagoj, en fenomenoj, en ĉi-momento, sed ne en evoluo. 
			Por ili estas pli facile ellerni 100 apartajn vortojn aŭ esprimojn, ol ekposedi nur 10 da ili plus la regulon, kiel produkti aliujn 90 el tiuj 10. Ĝuste tial sufiĉe multaj personoj povas sur iel-tiel kontentiga nivelo ekposedi la anglan, kun ĝiaj sennombraj ekskludoj; - sed ja ĉiuj tiuj ekskludoj jam estas indikitaj, oni ne devas PENSI kaj KOMPRENI – nur memorfiksi la jam preskribitan! 
			Klare, ke por tiaj homoj facileco de nia lingvo tute ne estas evidenta.
		</p>
		
		<p class="mb-2">
			Tial ne povas ekzisti unusola metodo por instrui Esperanton al ĉiuj.
		</p>
		
		<p class="mb-2">
			Laŭ mia opinio, por havi bonajn rezultojn en instruado, oni devus dekomence kontroli aŭditorion per la plej facilaj metodoj. 
			Ekzemple, homoj kun domino de la dekstra cerba hemisfero, se petataj krucigi la brakojn surbruste, kutime maldekstran brakon metas supren.
		</p>
		
		<p class="mb-2">
			Se ekzistas eblo, oni povas uzi ankaŭ pli komplikajn kontrolilojn, kaj poste, laŭ iliaj rezultoj, dividi sian grupon kaj apliki al ĉiu areto ĝuste tiun metodikon, kiun ili bezonas. 
			Instrui logike al logikemuloj kaj sense al sensemuloj (per ludoj, kantoj, teatraĵetoj).
		</p>
		
		<p class="mb-2">
			Tio ŝajnas esti malŝparo de fortoj de instruisto, sed rezultoj de tia «homkongrua» instruado estos multoble pli sukcesaj, ol se oni aplikos unusaman metodikon al plej diversaj individuoj!
		</p>
		
		<p class="mb-2">
			Ĉu fortoj de instruisto ne multobliĝas, se li vidas fruktodonecon de sia laboro?
		</p>
		
		<p class="mb-2">
			Ĉu la celo de instruisto ne estas elformi LINGVOPOSEDANTON? Homon, kiu ĜOJOS pro sia kono de la lingvo, kaj tial volonte uzas ĝin?
		</p>
		
		<p class="mb-4">
			Do, kreu ni kontentajn homojn, feliĉajn homojn, kaj tial Esperanto prosperos en estonto <span style="font-size: 24px">&#9786;</span>
		</p>
		
		<p class="mb-2">
			Mi komprenas, certe, ke instruisto mem posedas sian propran individuecon, kaj li povas agi nur laŭ sia propra naturo; kaj ke lernantojn allogas ne nur la lingvo, sed, eble ĉefe, la personeco de instruisto. 
			Kaj lernantoj de iu instruisto havas ion komunan inter si mem kaj iamaniere similas al la instruisto, ĉar dividas kun li liajn ideojn, liajn inklinojn kaj kredojn – aliel kial ili restu liaj gelernantoj, se nenio el tio, kion proklamas la instruisto, interesas kaj allogas ilin? Tio estas absolute klara fenomeno ĝuste en instruado de Esperanto, nedeviga kaj ŝajne nebezonata objekto, kiu «estas lernigata nur per iuj specialaj rilatoj inter proponanto kaj ricevanto de tiel specifa aĵo, kiel internacia lingvo».
		</p>
		
		<p class="mb-2">
			Eble, en la epoko de Interreta studado rezonadoj pri la rolo de instruisto sonas ridinde: pri kiu klubo, kurso kun maksimume kelkdek personoj oni arogas paroli, se rete lernas dekmiloj? 
			Sed komparu ni la rendimenton, efektivecon de ambaŭ tipoj: ĉu egalas, kiam restas unu lernanto el 20, kaj unu el 2000? Kiom ajn la mondo penas senigi nin de ajnaj homaj, interhomaj rilatoj, tamen ili persistas… kaj ofte ĝuste en E-kluboj.
		</p>
		
		<p class="mb-3">
			La plej saĝa solvo de preskaŭ ĉiuj problemoj estas: ne «aŭ…aŭ» , sed «kaj…kaj». 
			En la reto ekzistas bonegaj instruiloj por ĉies gusto. Oni ĉerpu libere kaj plenmane, ankaŭ por modesta hom-al-homa instruado. 
			Kaj rilate al diversaj tipoj de instruado, mi devas diri, ke mi tute ne alvokas niajn geinstruistojn duoniĝi kaj agi kontraŭ ilia propra personeco, sed  proponas, male, ke ili  kredu al si mem kaj ne obeu al unusola «ĉionkonkera» metodiko, sed disvolvu siajn proprajn eblecojn. 
			Ja «homkongrua» pedagogiko devas kongrui ne nur kun instruataj, sed ankaŭ kun instruantaj!
		</p>
		
		<p class="mb-3">
			Se plej diversaj instruistoj produktos plej diversajn esperantistojn, tiam Esperanto, eble, «ĝisvivos ĝis 2020-a jaro», kaj ne restos nur bizara hobio de malvasta kaj maljuna grupeto.
		</p>
		
		<p class="mb-3">
			Esperanto donis feliĉon al nia vivo; kial ĝi ne prilumigu ankaŭ vivojn de niaj genepoj?
		</p>
		`
	)
}

const itemName = {
	esp: 'Ĉu estas facila nia lingvo Esperanto'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp
	}
};

export default item;